<template>
    <div>
        <Language :add="add" v-model="form.lang" @change="handleLangChange"></Language>
        <el-form ref="form" :model="form" :rules="rules" label-width="100px">
            <el-form-item label="排序" prop="sort">
                <el-input v-model="form.sort" placeholder="请输入排序" style="width: 300px"></el-input>
            </el-form-item>
            <el-form-item label="优惠券类型" prop="type">
                <el-radio-group v-model="form.type">
                    <el-radio label="1">满减券</el-radio>
                    <el-radio label="2">无门槛券</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="优惠券名称" prop="name">
                <el-input v-model="form.name" placeholder="请输入优惠券名称" style="width: 300px"></el-input>
            </el-form-item>
            <el-form-item label="优惠金额">
                <el-row v-if="form.type == 1" type="flex" align="middle">
                    满
                    <el-form-item label="" prop="condition_money">
                        <el-input v-model="form.condition_money" placeholder="请输入金额" style="width: 200px; margin: 0 10px">
                            <template slot="append">元</template>
                        </el-input>
                    </el-form-item>
                    减
                    <el-form-item label="" prop="type_money">
                        <el-input v-model="form.type_money" placeholder="请输入金额" style="width: 200px; margin: 0 10px">
                            <template slot="append">元</template>
                        </el-input>
                    </el-form-item>
                </el-row>
                <el-form-item v-else prop="type_money">
                    <el-input v-model="form.type_money" placeholder="输入可抵扣金额" style="width: 300px">
                        <template slot="append">元</template>
                    </el-input>
                </el-form-item>
            </el-form-item>
            <el-form-item label="渠道" prop="qd">
                <el-select v-model="form.qd" placeholder="请选择渠道">
                    <el-option value="jd" label="京东"></el-option>
                    <el-option value="taobao" label="淘宝"></el-option>
                    <el-option value="tmall" label="天猫"></el-option>
                    <el-option value="amazon" label="亚马逊"></el-option>
                    <el-option value="aliExpress" label="速卖通"></el-option>
                    <el-option value="shopify" label="Shopify"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="卡券编号" prop="jmbh">
                <el-input v-model="form.jmbh" placeholder="请输入卡券编号"></el-input>
            </el-form-item>
            <el-form-item label="有效期" prop="date">
                <el-date-picker
                    v-model="form.date"
                    type="daterange"
                    align="left"
                    unlink-panels
                    range-separator="-"
                    value-format="yyyy-MM-dd"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions"
                >
                </el-date-picker>
            </el-form-item>
            <el-form-item label="适用范围" prop="applicable_scope">
                <el-radio-group v-model="form.applicable_scope">
                    <div class="vertical-item">
                        <el-radio label="1">全场通用</el-radio>
                    </div>
                    <div class="vertical-item">
                        <el-radio label="2">指定商品可用</el-radio>
                        <el-button :disabled="form.applicable_scope != 2" type="text" icon="el-icon-plus" @click="handlePick">选择商品</el-button>
                        <el-tag style="margin-left: 10px" v-for="item in goods" :key="item.uuid">{{ item.name }}</el-tag>
                    </div>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="领取国家限制" prop="country_scope">
                <el-radio-group v-model="form.country_scope" @change="handleCountryScopeChange">
                    <el-radio label="1">所有国家</el-radio>
                    <el-radio label="2">指定国家可领</el-radio>
                    <Country :disabled="form.country_scope != 2" v-model="form.country"></Country>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="详细说明" prop="desc">
                <el-input :rows="5" type="textarea" placeholder="请输入详细说明" v-model="form.desc"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button @click="$router.back()">取消</el-button>
                <el-button type="primary" @click="handleConfirm">确定</el-button>
            </el-form-item>
        </el-form>
        <GoodsMultiplePickerWithCategory ref="goodsPicker" @pick="goodsPick" v-model="goods"></GoodsMultiplePickerWithCategory>
    </div>
</template>

<script>
import Language from "@/components/Language";
import Country from "@/components/Country";
import GoodsMultiplePickerWithCategory from "@/components/GoodsMultiplePickerWithCategory";
import { add, edit, detail } from "@/api/coupon/list";
import { getUuid } from "@/jslibs/utils";
export default {
    components: { Language, Country, GoodsMultiplePickerWithCategory },
    data() {
        return {
            pickerOptions: {
                disabledDate: (date) => {
                    return date.getTime() < Date.now() - 8.64e7;
                },
            },
            form: {
                sort: "",
                type: "1",
                name: "",
                condition_money: "",
                type_money: "",
                date: null,
                applicable_scope: "1",
                country_scope: "1",
                lang: "zh",
                qd: "",
                jmbh: "",
            },
            rules: {
                sort: [{ required: true, message: "请输入排序" }],
                type: [{ required: true, message: "请选择优惠券类型" }],
                name: [{ required: true, message: "请输入优惠券名称" }],
                condition_money: [{ required: true, message: "请输入门槛金额" }],
                type_money: [{ required: true, message: "请输入抵扣金额" }],
                date: [{ required: true, message: "请选择有效期" }],
            },
            isEdit: false,
            cuuid: null,
            goods: [],
            add: true,
        };
    },
    mounted() {
        const cuuid = this.$route.query.cuuid;
        if (cuuid) {
            this.add = false;
            this.isEdit = true;
            this.form.cuuid = cuuid;
            this.getDetail();
        } else {
            this.add = true;
            this.isEdit = false;
            this.form.cuuid = getUuid();
        }
    },
    methods: {
        getDetail() {
            detail({ cuuid: this.form.cuuid, lang: this.form.lang }).then(({ code, result, error }) => {
                if (code === 200) {
                    this.form = result
                        ? { ...result, date: [] }
                        : { cuuid: this.form.cuuid, lang: this.form.lang, type: "1", applicable_scope: "1", country_scope: "1", date: [] };
                    this.cuuid = result ? result.cuuid : null;
                    this.goods = result ? result.goods : [];
                    if (result && result.validity_start_date && result.validity_end_date) {
                        this.form.date = [result.validity_start_date, result.validity_end_date];
                    }
                    if (result && result.country) {
                        this.form.country = result.country.map((x) => x.id);
                    }
                    this.$nextTick(() => {
                        this.$refs.form.clearValidate();
                    });
                } else {
                    this.$message.error(error.message);
                }
            });
        },
        handleCountryScopeChange(value) {
            if (value == 1) {
                this.form.country = [];
            }
        },
        handleLangChange() {
            this.getDetail();
        },
        handlePick() {
            this.$refs.goodsPicker.open();
        },
        goodsPick(data) {
            this.goods = data;
        },
        handleConfirm() {
            this.$refs.form.validate((valid) => {
                if (!valid) return;
                const params = {
                    ...this.form,
                    validity_start_date: this.form.date && this.form.date[0] ? this.form.date[0] : null,
                    validity_end_date: this.form.date && this.form.date[1] ? this.form.date[1] : null,
                    goods: this.goods.map((x) => x.uuid),
                };
                delete params.date;
                if (this.isEdit) {
                    if (this.cuuid) {
                        edit(params).then(({ code, error }) => {
                            if (code === 200) {
                                this.$message.success("编辑成功");
                                this.$router.back();
                            } else {
                                this.$message.error(error.message);
                            }
                        });
                    } else {
                        add(params).then(({ code, error }) => {
                            if (code === 200) {
                                this.$message.success("添加成功");
                                this.$router.back();
                            } else {
                                this.$message.error(error.message);
                            }
                        });
                    }
                } else {
                    add(params).then(({ code, error }) => {
                        if (code === 200) {
                            this.$message.success("添加成功");
                            this.$router.back();
                        } else {
                            this.$message.error(error.message);
                        }
                    });
                }
            });
        },
    },
};
</script>

<style></style>
